import { render } from "./header-title.vue?vue&type=template&id=5e39c898"
import script from "./header-title.vue?vue&type=script&setup=true&lang=js"
export * from "./header-title.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/header-title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e39c898"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e39c898', __exports__)) {
    console.log('reload')
    api.reload('5e39c898', __exports__)
  }
  
  module.hot.accept("./header-title.vue?vue&type=template&id=5e39c898", () => {
    console.log('re-render')
    api.rerender('5e39c898', render)
  })

}


export default __exports__